import type { MerchantNavSection } from '@favelafood/shared/components/merchant/shell/nav';

export type { MerchantNavItem, MerchantNavSection } from '@favelafood/shared/components/merchant/shell/nav';

// STAFF_NAV / navForRoles left with the staff carve (apps/staff, C2). The admin
// merchant-app shell is owner-only now — staff logs in on its own subdomain.
export const MERCHANT_NAV: readonly MerchantNavSection[] = [
  { items: [
    { label: 'Resumo da loja', to: '/', icon: 'LayoutDashboard' },
  ] },
  { title: 'Operação', items: [
    { label: 'Histórico de pedidos', to: '/pedidos', icon: 'Package' },
    { label: 'Financeiro', to: '/financeiro', icon: 'Wallet' },
    { label: 'Avaliações', to: '/avaliacoes', icon: 'Star' },
  ] },
  { title: 'Catálogo', items: [
    { label: 'Produtos', to: '/produtos', icon: 'UtensilsCrossed' },
    { label: 'Categorias', to: '/categorias', icon: 'Tags' },
    { label: 'Promoções', to: '/promocoes', icon: 'Percent' },
  ] },
];
